import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Cookies } from 'src/app/lib/cookies';
import isEmpty from 'src/app/lib/isEmpty';
import { toFixedDown, convert, truncateDecimals, longDecimals, fraction, nFormatter } from 'src/app/lib/roundOf';
import { SocketService } from 'src/app/services/socket.service';
import { SpotService } from 'src/app/services/spot.service';
import { WalletService } from 'src/app/services/wallet.service';
import { TradeAssetFacade } from 'src/app/store/bot-trade-asset';
import { PairFacade } from 'src/app/store/botpair';
import { MarketPriceFacade } from 'src/app/store/marketprice';
import { spotSocket } from 'src/app/app.module';
import { environment } from 'src/environments/environment';

interface CryptoPair {
  _id: string;
  tikerRoot: string;
  firstCurrencySymbol: string;
  secondCurrencySymbol: string;
  firstCurrencyImage: string;
  secondCurrencyImage: string;
  last: number;
  markPrice: number;
}

@Component({
  selector: 'app-exchange-price',
  templateUrl: './exchange-price.component.html',
  styleUrls: ['./exchange-price.component.css']
})
export class ExchangePriceComponent {
  @Input() tikerRoot: any
  toFixedDown = toFixedDown
  convert = convert
  truncateDecimals = truncateDecimals
  longDecimals = longDecimals
  fraction = fraction
  nFormatter = nFormatter

  pairs: any = {}
  currencies: any = []
  activeCurrency: string = '';
  pairData: any = {}
  favPairList: any
  favPairData: any = []
  searchPair: string = ''
  searchTerm: string = ''
  quoteCurrency: string = 'BTC'
  isDropdownOpen = false;
   url = 'https://www.credbull.in/';
  // Replace hardcoded data with API-driven properties
  selectedPair: any = null;
  currencyPairs: any[] = [];
  bestAskPrice = 0;
  packageAmount = 0;
  packageProfit = 0;

  constructor(
    private service: SpotService,
    private walletService: WalletService,
    private pairFacade: PairFacade,
    private tradeAssetFacade: TradeAssetFacade,
    private router: Router,
    private cookies: Cookies,
    private spotSocket: spotSocket,
    private socketService: SocketService,
    private marketPriceFacade: MarketPriceFacade,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.getFavList()
    this.getPairList()
    this.spotSocket.on('marketPrice', this.marketPriceWs.bind(this))
    if (this.tikerRoot) {
      this.quoteCurrency = this.tikerRoot.split('_')[1]
    }
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectPair(pair: any): void {
        this.selectedPair = {
          name: `XRP_USDT`,
        };
   
    // this.selectedPair = {
    //   image: `${this.url}${pair.firstCurrencyImage}`,
    //   name: `${pair.firstCurrencySymbol}/${pair.secondCurrencySymbol}`,
    //   price: pair.last || pair.markPrice || 0,
    //   change: pair.change || 0,
    //   secondCurrencySymbol: pair.secondCurrencySymbol,
    // };
    // this.isDropdownOpen = false;
    // this.searchTerm = '';
    // this.changePair(pair);
  }

  get filteredPairs() {
    return this.currencyPairs.filter(pair =>
      `${pair.firstCurrencySymbol}/${pair.secondCurrencySymbol}`.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      pair.firstCurrencySymbol.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      pair.secondCurrencySymbol.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  getFavList() {
    this.favPairList = localStorage.getItem('favPair');
    if (this.favPairList)
      this.favPairList = JSON.parse(this.favPairList)
  }

  getPairList() {
    this.service.getPairList()
      .subscribe({
        next: (v: any) => {
          if (v.success && v.result) {
            // Populate currencyPairs with API data
       this.currencyPairs = v.result
    .filter((pair: any) =>
    ['XRP'].includes(pair.firstCurrencySymbol) &&
    pair.secondCurrencySymbol === 'USDT'
  )
  .map((pair: any) => ({
    ...pair,
    image: pair.firstCurrencyImage || 'assets/media/images/default.png',
    name: `${pair.firstCurrencySymbol}/${pair.secondCurrencySymbol}`,
    price: pair.last || pair.markPrice || 0,
    change: pair.change || 0,
  }));

            if (isEmpty(this.tikerRoot)) {
              // Set first pair as default if no tikerRoot specified
              if (v.result.length > 0) {
                let pair = `${v.result[0].firstCurrencySymbol}_${v.result[0].secondCurrencySymbol}`
                //this.setSelectedPair(v.result[1]);
                   this.selectPair("XRP_USDT");
              }
            } else {
              this.pairFacade.setPair(v.result)
              const selectedPair = v.result.find((el: any) => el.tikerRoot === this.tikerRoot.replace('_', ''))

              if (selectedPair) {
                this.pairData = selectedPair;
                this.setSelectedPair(selectedPair);
                this.fetchAssetByCurrency(selectedPair.firstCurrencyId, 'firstCurrency')
                this.fetchAssetByCurrency(selectedPair.secondCurrencyId, 'secondCurrency')
                this.service.setTradePair(selectedPair)
                this.marketPriceFacade.setSpotMarketPrice(selectedPair)
              }

              this.pairs = v.result.reduce((acc: any[], curr: any) => {
                if (!acc[curr.secondCurrencySymbol]) {
                  acc[curr.secondCurrencySymbol] = [];
                  this.currencies.push(curr.secondCurrencySymbol)
                }
                acc[curr.secondCurrencySymbol].push(curr);
                return acc;
              }, {});

              this.favPairData = v.result.filter((element: any) => this.favPairList?.includes(element.tikerRoot))
              this.activeCurrency = this.currencies[0]
            }
          }
        },
        error: (err: any) => {
          console.error('Error fetching pair list:', err);
        }
      })
  }

  private setSelectedPair(pair: any) {
    this.selectedPair = {
      image: pair.firstCurrencyImage || 'assets/media/images/default.png',
      name: `${pair.firstCurrencySymbol}/${pair.secondCurrencySymbol}`,
      price: pair.last || pair.markPrice || 0,
      change: pair.change || 0,
    };
        this.bestAskPrice = pair.markPrice || pair.last || 0;
  }
 getCurrecyImage(currency: string) {
    const curr = this.selectedPair.find((el: any) => el.coin === currency);
    return curr?.image || "";
  }
  fetchAssetByCurrency(spotPairId: string, type: 'firstCurrency' | 'secondCurrency') {
    if (!this.cookies.isLogin())
      return
    this.walletService.getAssetByCurrency(spotPairId)
      .subscribe({
        next: (v: any) => {
          if (v.success) {
            if (type === 'firstCurrency')
              this.tradeAssetFacade.setFirstCurrency(v.result)
            else if (type === 'secondCurrency')
              this.tradeAssetFacade.setSecondCurrency(v.result)
          }
        },
        error: (err: any) => {
          console.error('Error fetching asset by currency:', err);
        }
      })
  }

  changePair(pair: any) { 
    const newPair = pair.firstCurrencySymbol + '_' + pair.secondCurrencySymbol
    const activePair = this.route.snapshot.params['tikerRoot']
    if (newPair == activePair) return;
    this.socketService.emit("unSubscribe", activePair.replace("_", ""));
    this.router.navigateByUrl('/arbitrage_bot/' + newPair)
    this.service.setTradePair(pair)
    this.fetchAssetByCurrency(pair.firstCurrencyId, 'firstCurrency')
    this.fetchAssetByCurrency(pair.secondCurrencyId, 'secondCurrency')
    this.pairData = pair;
    this.marketPriceFacade.setSpotMarketPrice(pair)
  }

  marketPriceWs(result: any) {
    if (result.pairId == this.pairData._id) {
      this.marketPriceFacade.setSpotMarketPrice(result.data)
      if (this.selectedPair && this.pairData.tikerRoot === this.tikerRoot?.replace('_', '')) {
        this.selectedPair.price = result.data.last || result.data.markPrice || this.selectedPair.price;
        this.bestAskPrice = result.data.markPrice || result.data.last || this.bestAskPrice;
      }
    }
  }

  addToFav(pair: any) {
    let favPair: any = JSON.parse(localStorage.getItem('favPair') || '[]');
    if (favPair.includes(pair.tikerRoot)) {
      favPair = favPair.filter((item: any) => item != pair.tikerRoot);
      this.favPairData = this.favPairData.filter((item: any) => item.tikerRoot !== pair.tikerRoot);
    }
    else {
      favPair.push(pair.tikerRoot);
      this.favPairData.push(pair);
    }
    localStorage.setItem('favPair', JSON.stringify(favPair));
    this.getFavList()
  }

  handleSearchPair(event: any) {
    this.searchPair = event.target.value.toUpperCase().replace('/', '')
  }
}